import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const userApi = tokenSlice.injectEndpoints({
  reducerPath: "user",
  baseQuery: createBaseQuery(),
  tagTypes: ["User"],
  endpoints(builder) {
    return {

      // GET

      getUserByToken: builder.query({
        query: () => {
          return {
            url: "User/GetUserByToken",
            method: "GET",
          };
        },
        providesTags: ["User"],
      }),

      getUserInfoId: builder.query({
        query: (id) => ({
          url: `User/GetUserInfo/${id}`,
          method: "GET",
        }),
        providesTags: ["User"],
      }),

      getCurrentUserInfo: builder.query({
        query: () => {
          return {
            url: "User/GetCurrentUserInfo",
            method: "GET",
          };
        },
        providesTags: ["User"],
      }),

      getUserWaiting: builder.query({
        query: (args) => {
          const { userStatus, userType, page, limit } = args;
          return {
            url: `User/GetUserWFA?userStatus=${userStatus}&userType=${userType}&page=${page}&limit=${limit}`,
          };
        },
        providesTags: ["User"],
      }),

      getUserAll: builder.query({
        query: (args) => {
          // Destructuring Object
          const { userStatus, userType, page, limit } = args;
          return {
            url: `User/GetUserAll?userStatus=${userStatus}&userType=${userType}`,
          };
        },
        providesTags: ["User"],
      }),

      getActiveUser: builder.query({
        query: () => {
          return {
            url: `User/GetActiveUsers`,
          };
        },
        providesTags: ["User"],
      }),

      getUserCompany: builder.query({
        query: (args) => {
          // Destructuring Object
          const { userStatus, page, limit } = args;
          return {
            url: `User/GetUserCompany?userStatus=${userStatus}&page=${page}&limit=${limit}`,
          };
        },
        providesTags: ["User"],
      }),

      getUserVendor: builder.query({
        query: (args) => {
          // Destructuring Object
          const { userStatus, page, limit } = args;
          return {
            url: `User/GetUserVendor?userStatus=${userStatus}&page=${page}&limit=${limit}`,
          };
        },
        providesTags: ["User"],
      }),

      getErpUser: builder.query({
        query: () => {
          return {
            url: "User/GetERPUser",
            method: "GET",
          };
        },
        providesTags: ["User"],
      }),

      getGroupByUser: builder.query({
        query: (id) => ({
          url: `User/GetGroupsByUserId?userId=${id}`,
          method: "GET",
        }),
        providesTags: ["User"],
      }),

      getUserId: builder.query({
        query: (userId) => {
          return {
            url: `/User/GetUserInfo/${userId}`,
            method: "GET",
          };
        },
        providesTags: ["User"],
      }),

      // POST

      postUserSendToApprove: builder.mutation({
        query: (data) => ({
          url: "User/UserSendToApprove",
          method: "POST",
          body: data,
        }),
        providesTags: ["User"],
      }),

      postSupport: builder.mutation({
        query: (data) => ({
          url: "Support/Save",
          method: "POST",
          body: data,
        }),
        providesTags: ["User"],
      }),

      postUserWaiting: builder.mutation({
        query: (waiting) => ({
          url: "User/GetUserWFA",
          method: "POST",
          body: waiting,
        }),
        providesTags: ["User"],
      }),
      postUserAll: builder.mutation({
        query: (waiting) => ({
          url: "User/GetUserAll",
          method: "POST",
          body: waiting,
        }),
        invalidatesTags: ["User"],
      }),
      postUserSave: builder.mutation({
        query: (formData) => ({
          url: "User/SaveUser",
          method: "POST",
          body: formData,
        }),
        invalidatesTags: ["User"],
      }),

      postUserCompany: builder.mutation({
        query: (company) => ({
          url: `User/GetUserCompany?allStatus=true`,
          method: "POST",
          body: company,
        }),
        invalidatesTags: ["User"],
      }),

      postUserChangeStatus: builder.mutation({
        query: (changeStatus) => ({
          url: "User/UserChangeStatus",
          method: "POST",
          body: changeStatus,
        }),
        invalidatesTags: ["User"],
      }),

      postUserChangePassword: builder.mutation({
        query: (password) => ({
          url: "User/ChangeUserPassword",
          method: "POST",
          body: password,
        }),
        invalidatesTags: ["User"],
      }),

      postGroupToUser: builder.mutation({
        query: (addUserGroup) => ({
          url: "User/AddGroupToUser",
          method: "POST",
          body: addUserGroup,
        }),
        invalidatesTags: ["User"],
      }),

      changeUserLanguage: builder.mutation({
        query: (language) => ({
          url: `User/ChangeUserLanguage?language=${language}`,
          method: "POST",
        }),
        invalidatesTags: ["User"],
      }),

      // DELETE

      deleteUser: builder.mutation({
        query: (deleteUser) => ({
          url: `User/DeleteUser`,
          method: "DELETE",
          body: deleteUser,
        }),
        invalidatesTags: ["User"],
      }),

      deleteGroupFromUser: builder.mutation({
        query: (deleteGroup) => ({
          url: `User/DeleteGroupFromUser`,
          method: "POST",
          body: deleteGroup,
        }),
        invalidatesTags: ["User"],
      }),
    };
  },
});

export const {
  useChangeUserLanguageMutation,
  useGetUserByTokenQuery,
  usePostUserWaitingMutation,
  usePostUserAllMutation,
  usePostUserSaveMutation,
  usePostUserCompanyMutation,
  useGetActiveUserQuery,
  useGetUserCompanyQuery,
  useGetUserVendorQuery,
  usePostUserChangeStatusMutation,
  useGetErpUserQuery,
  useDeleteUserMutation,
  useGetUserIdQuery,
  useGetUserAllQuery,
  useGetUserWaitingQuery,
  useGetGroupByUserQuery,
  useDeleteGroupFromUserMutation,
  usePostGroupToUserMutation,
  usePostUserChangePasswordMutation,
  useGetCurrentUserInfoQuery,
  usePostSupportMutation,
  usePostUserSendToApproveMutation
} = userApi;
export { userApi };

// import { tokenSlice.injectEndpoints, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

// const userApi = tokenSlice.injectEndpoints({
//     reducerPath: 'users',
//     baseQuery: fetchBaseQuery({
//         baseUrl: 'http://localhost:3005'
//     }),
//     endpoints(builder) {
//         return {
//             fetchUsers: builder.query({
//                 query: () => {
//                     return {
//                         url: '/users',
//                         method: 'GET'
//                     }
//                 }
//             }),
//             getUser: builder.query({
//                 query: () => {
//                     return {
//                         url: '/users',
//                         method: 'GET'
//                     }
//                 },
//                 providesTags: ['User']
//             }),
//             addUser: builder.mutation({
//                 query: (user) => ({
//                     url: '/users',
//                     method: 'POST',
//                     body: user
//                 }),
//                 invalidatesTags: ['User']
//             }),
//             updateUser: builder.mutation({
//                 query: (user) => ({
//                     url: `/users/${user.id}`,
//                     method: 'PATCH',
//                     body: user
//                 }),
//                 invalidatesTags: ['User']
//             }),
//             deleteUser: builder.mutation({
//                 query: ({ id }) => ({
//                     url: `/users/${id}`,
//                     method: 'DELETE',
//                     body: id
//                 }),
//                 invalidatesTags: ['User']
//             })
//         }
//     }
// })

// export const { useFetchUsersQuery, useGetUserQuery, useAddUserMutation, useUpdateUserMutation, useDeleteUserMutation } = userApi;
// export { userApi };
